import __request__ from "routing/request";
export function search(JSONBody) {
  return __request__("POST", "/quickjump", JSONBody, {}, {
    "Accept": ["application/json"]
  });
}
